module.exports = __webpack_public_path__ + "media/images/countrysquared/nl-75c5c9ae441881ac40a17985897d3026.svg";